"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

require("../assets/css/root.css");

require("../assets/css/font-face.css");

require("./ActionBar.css");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};

    if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
          var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {};

          if (desc.get || desc.set) {
            Object.defineProperty(newObj, key, desc);
          } else {
            newObj[key] = obj[key];
          }
        }
      }
    }

    newObj.default = obj;
    return newObj;
  }
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest();
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance");
}

function _iterableToArrayLimit(arr, i) {
  var _arr = [];
  var _n = true;
  var _d = false;
  var _e = undefined;

  try {
    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

var ActionBar = function ActionBar(_ref) {
  var onSearch = _ref.onSearch,
      _onClick = _ref.onClick,
      onFilter = _ref.onFilter,
      actions = _ref.actions,
      filters = _ref.filters,
      _ref$className = _ref.className,
      className = _ref$className === void 0 ? '' : _ref$className;

  var _useState = (0, _react.useState)(''),
      _useState2 = _slicedToArray(_useState, 2),
      searchValue = _useState2[0],
      setSearchValue = _useState2[1];

  var wrapperClass = 'actionbar';
  if (className) wrapperClass += " ".concat(className);

  var handleSubmit = function handleSubmit(event) {
    event.preventDefault();
    onSearch(searchValue);
    setSearchValue(searchValue);
  };

  var renderAction = function renderAction(_ref2) {
    var action = _ref2.action,
        title = _ref2.title,
        _ref2$danger = _ref2.danger,
        danger = _ref2$danger === void 0 ? false : _ref2$danger;
    var actionClass = 'actionbar__action';
    if (danger) actionClass += ' actionbar__action--danger';
    return _react.default.createElement("span", {
      onClick: function onClick() {
        return _onClick(action);
      },
      className: actionClass,
      key: action
    }, title);
  };

  var renderFilters = function renderFilters() {
    return filters.map(function (filter, i) {
      return _react.default.createElement("select", {
        onChange: function onChange(_ref3) {
          var target = _ref3.target;
          return onFilter(target.value);
        },
        key: i
      }, filter.map(function (option, j) {
        return _react.default.createElement("option", {
          value: option.value,
          key: j
        }, option.title);
      }));
    });
  };

  return _react.default.createElement("div", {
    className: wrapperClass
  }, _react.default.createElement("div", {
    className: "actionbar__actions"
  }, actions.map(function (action) {
    return renderAction(action);
  })), _react.default.createElement("div", {
    className: "actionbar__right"
  }, _react.default.createElement("form", {
    className: "actionbar__search",
    onSubmit: handleSubmit
  }, _react.default.createElement("svg", {
    width: "18",
    height: "16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, _react.default.createElement("circle", {
    cx: "7.3913",
    cy: "7.3913",
    r: "6.3913",
    stroke: "#868686",
    strokeWidth: "2"
  }), _react.default.createElement("path", {
    fill: "#868686",
    d: "M13.2118 11l4.19526165 3.19522714-1.21180741 1.59107598-4.19526165-3.19522713z"
  })), _react.default.createElement("input", {
    type: "text",
    placeholder: "Buscar",
    onChange: function onChange(_ref4) {
      var target = _ref4.target;
      return setSearchValue(target.value);
    },
    value: searchValue
  })), renderFilters()));
};

ActionBar.defaultProps = {
  onSearch: function onSearch() {},
  onClick: function onClick() {},
  onFilter: function onFilter() {},
  actions: [],
  filters: []
};
ActionBar.propTypes = {
  /** Função executada após o envio do formulário de busca */
  onSearch: _propTypes.default.func,

  /** Função executada após selecionar alguma ação */
  onClick: _propTypes.default.func,

  /** Função executada após modificar algum filtro */
  onFilter: _propTypes.default.func,

  /** Array de dados contendo as ações que podem ser realizadas */
  actions: _propTypes.default.array,

  /** Array contendo objetos que representam os filtros */
  filters: _propTypes.default.array
};
var _default = ActionBar;
exports.default = _default;